import React, { ComponentProps } from 'react'
import Lightbox, { ImagesListType } from 'react-spring-lightbox'

import { ImageLightboxHeader } from './ImageLightBoxHeader'
import { StyledCheveronIcon, StyledLightBox, StyledLightboxButton } from './StyledLightBox'

export type ImageLightboxProps = {
  open: boolean
  currentImageIndex: number
  setCurrentIndex: (index: number) => void
  onClose: () => void
  images: ImagesListType
}

export const ImageLightbox: React.FC<ImageLightboxProps> = ({ open, currentImageIndex, setCurrentIndex, onClose, images }) => {
  const gotoPrevious = () => {
    if (currentImageIndex > 0) {
      setCurrentIndex(currentImageIndex - 1)
    }
  }

  const gotoNext = () => {
    if (currentImageIndex + 1 < images.length) {
      setCurrentIndex(currentImageIndex + 1)
    }
  }

  const leftChevron: ComponentProps<typeof Lightbox>['renderPrevButton'] = () => (
    <StyledLightboxButton
      $isLeft
      disableRipple
      onClick={gotoPrevious}
      disabled={currentImageIndex === 0}
    >
      <StyledCheveronIcon iconCode="chevronleft" />
    </StyledLightboxButton>
  )

  const nextChevron: ComponentProps<typeof Lightbox>['renderPrevButton'] = () => (
    <StyledLightboxButton
      $isLeft={false}
      disableRipple
      onClick={gotoNext}
      disabled={currentImageIndex + 1 === images.length}
    >
      <StyledCheveronIcon iconCode="chevronright" />
    </StyledLightboxButton>
  )

  // eslint-disable-next-line react/no-unstable-nested-components
  const CustomHeader: ComponentProps<typeof Lightbox>['renderHeader'] = () => (<ImageLightboxHeader onClose={onClose} />)


  return (
    <StyledLightBox
      isOpen={open}
      onClose={onClose}
      onPrev={gotoPrevious}
      onNext={gotoNext}
      images={images}
      currentIndex={currentImageIndex}
      singleClickToZoom

      /* Add your own UI */
      renderHeader={CustomHeader}
      // renderFooter={() => (<CustomFooter />)}
      renderPrevButton={leftChevron}
      renderNextButton={nextChevron}

      /* Use single or double click to zoom */
      pageTransitionConfig={{
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: { mass: 1, tension: 320, friction: 32 },
      }}
    />
  )
}
